module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab9",
      "name": "hres31x-tab9"
    }
  }, [_c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['10']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['namspous']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numoffid']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codspocc']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dtespbd'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['desnoffi']))])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['80']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dtemarry'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codsppro']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codspcty']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['desplreg']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['desnote']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['idf']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC9']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['idm']))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-715ffc70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab9.vue
// module id = 3856
// module chunks = 1